import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        switch: false, // 悬浮窗切换
        information:{}, // 用户信息
        signup:false, // 报名判断
        options:[] // 省级列
    },
    mutations: {
        modify(state,status){
            state.switch = status
        },
        inform(state, status) {
            state.information = status
        },
        signupz(state, status) {
            state.signup = status
        },
        optionsz(state, status) {
            state.options = status
        },
    },
    getters: {

    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js